import { useOutletContext } from 'react-router-dom';
import { ProductType } from '~/models/product/ProductType';
import { MappedCampaign } from '../v2.utils';
import { ProductGroupV2 } from '../components/ProductGroupV2';

export const SelectPremiumProducts: React.FC = () => {
  const campaign = useOutletContext<MappedCampaign>();
  return <ProductGroupV2 group={campaign.products.premium} config={campaign.configs.premium} type={ProductType.Premium} />;
};
